import { LottieAnimation } from '../../../components/Loader/LottieAnimation';
import ProgressBar from '../../../components/ProgressBar/ProgressBar';
import styles from './GiftIcon.module.css';

const GiftItem = ({
  img,
  progress,
  allProgress,
  name,
  openModal,
  animation,
}: {
  img: string;
  progress: number;
  allProgress: number;
  name: string;
  openModal?: () => void;
  animation?: string;
}) => {
  return (
    <div onClick={openModal} className={progress == allProgress ? styles.inventoryItemFull : styles.inventoryItem}>
      <div className={`${styles.inventoryEmoji} ${allProgress > progress ? styles.emojiDarkened : ''}`}>
        {animation ? (
          <LottieAnimation
            animationData={animation}
            style={{
              width: '62px',
              height: '62px',
              objectFit: 'contain',
            }}
            loop={false}
            autoplay={true}
          />
        ) : (
          <img src={img} alt="Gift" 
            className={progress === allProgress ? '' : 'darkImg'}/>
        )}
      </div>
      <span className={styles.inventoryName}>{name}</span>
      {progress == allProgress ? (
        <div className={styles.inventoryBtnContainer}>
          <button>Забрать</button>
        </div>
      ) : (
        <ProgressBar progress={progress} allProgress={allProgress}/>
      )}

    </div>
  );
};

export default GiftItem;
